import { User } from '../model/types';

export const users: User[] = [
  {
    FloorplanId: 23,
    TenantRoomId: 30154,
    uuid: '2',
    name: 'Namarata',
    status: 'away',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98624/avatars/avatar_98624_202504150736.jpg',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'Survey', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30153,
    uuid: '1',
    name: 'Jaya',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98625/avatars/avatar_98625_202410170606.jpg',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'Survey', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30028,
    uuid: '3',
    name: 'Arun',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98622/avatars/avatar_98622_202412311426.jpg',
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30311,
    uuid: '4',
    name: 'Nik',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/95481/avatars/avatar_95481_202407151359.jpg',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'FCR', value: '65%' },
      { key: 'SC+', value: '7' },
      { key: 'ASA', value: '00.00.34' },
      { key: 'FCR', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  // Meeting Room users for 23 Floor Plan
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '5',
    name: 'Jaya',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98625/avatars/avatar_98625_202410170606.jpg',
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '6',
    name: 'Jaya',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98625/avatars/avatar_98625_202410170606.jpg',
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '7',
    name: 'Namarata',
    status: 'away',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98624/avatars/avatar_98624_202504150736.jpg',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'Survey', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '8',
    name: 'Jaya',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98625/avatars/avatar_98625_202410170606.jpg',
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '9',
    name: 'Namarata',
    status: 'away',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/98624/avatars/avatar_98624_202504150736.jpg',
  },
  {
    FloorplanId: 23,
    TenantRoomId: 30103,
    uuid: '10',
    name: 'Nik',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/95481/avatars/avatar_95481_202407151359.jpg',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'Survey', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  // Meeting Room users for 23 Floor Plan
  {
    FloorplanId: 134,
    TenantRoomId: 30532,
    uuid: '11',
    name: 'Gregory Grant',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/99303/avatars/avatar_99303_202412041718.JPG',
  },
  {
    FloorplanId: 134,
    TenantRoomId: 30532,
    uuid: '12',
    name: 'Jane Smith',
    status: 'away',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/357/83641/avatars/avatar_83641_2022-07-22T01_25_33.1501044%2B00_00.jpeg',
  },
  {
    FloorplanId: 134,
    TenantRoomId: 30532,
    uuid: '13',
    name: 'Vivian Haydar',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/94244/avatars/avatar_94244_202404151247.jpeg',
  },
  {
    FloorplanId: 134,
    TenantRoomId: 30528,
    uuid: '14',
    name: 'John J Flores',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/1091/94520/avatars/avatar_94520_202503241813.png',
  },
  // Meeting Room users for 118 Floor Plan
  {
    FloorplanId: 118,
    TenantRoomId: 26501,
    uuid: '15',
    name: 'Susan Brown',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88042/avatars/avatar_88042_2023-06-13T12_11_42.5161151%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'FCR', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26502,
    uuid: '15',
    name: 'Michael Green',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88043/avatars/avatar_88043_2023-06-13T12_11_54.7615828%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.06' },
      { key: 'Survey', value: '85%' },
      { key: 'SC+', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26503,
    uuid: '15',
    name: 'Sarah White',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88044/avatars/avatar_88044_2023-06-13T12_18_15.3771697%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.09' },
      { key: 'Survey', value: '78%' },
      { key: 'SC+', value: '3' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 265043,
    uuid: '15',
    name: 'David Williams',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88045/avatars/avatar_88045_2023-06-13T12_18_36.7409534%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.07' },
      { key: 'Survey', value: '92%' },
      { key: 'SC+', value: '7' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26514,
    uuid: '15',
    name: 'Christopher Hernandez',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88055/avatars/avatar_88055_2023-06-13T12_26_05.9128735%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26526,
    uuid: '15',
    name: 'Robert Sanchez',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88067/avatars/avatar_88067_2023-06-13T12_32_13.9409451%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26525,
    uuid: '15',
    name: 'Maria Ortega',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88066/avatars/avatar_88066_2023-06-13T12_32_07.2035396%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26524,
    uuid: '15',
    name: 'Andrew Rivera',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88065/avatars/avatar_88065_2023-06-13T12_31_58.0702923%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26523,
    name: 'Ashley Alvarez',
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88064/avatars/avatar_88064_2023-06-13T12_31_51.0252610%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26529,
    name: 'Luis Lopez',
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88070/avatars/avatar_88070_2023-06-13T12_33_16.5497294%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26528,
    name: 'Jose Gonzalez',
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88069/avatars/avatar_88069_2023-06-13T12_33_27.8166359%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 26522,
    name: 'Steven Castillo',
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88063/avatars/avatar_88063_2023-06-13T12_29_49.5719496%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    FloorplanId: 118,
    TenantRoomId: 31098,
    name: 'Kelly Harris - Executive Admin',
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88055/avatars/avatar_88055_2023-06-13T12_26_05.9128735%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26516,
    name: 'Daniel Rodriguez',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88057/avatars/avatar_88057_2023-06-13T12_26_22.9205595%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26517,
    name: 'Emily Garcia',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88058/avatars/avatar_88058_2023-06-13T12_26_33.6341334%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26518,
    name: 'Nathan Perez',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88059/avatars/avatar_88059_2023-06-13T12_29_13.0944895%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26519,
    name: 'Victoria Sanchez',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88060/avatars/avatar_88060_2023-06-13T12_29_21.6055603%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26520,
    name: 'Kevin Lopez',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88061/avatars/avatar_88061_2023-06-13T12_29_32.5976499%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26515,
    name: 'Kelly Miller',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88056/avatars/avatar_88056_2023-06-13T12_26_14.0984643%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26504,
    name: 'David Williams',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88045/avatars/avatar_88045_2023-06-13T12_18_36.7409534%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26500,
    name: 'Bill Jones',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88055/avatars/avatar_88055_2023-06-13T12_26_05.9128735%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26505,
    name: 'Caroline Martin',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88046/avatars/avatar_88046_2023-06-13T12_18_57.5305779%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26499,
    name: 'Jane Doe',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88055/avatars/avatar_88055_2023-06-13T12_26_05.9128735%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26506,
    name: 'Eric Anderson',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88047/avatars/avatar_88047_2023-06-13T12_19_19.2767227%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26507,
    name: 'Jessica Taylor',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88048/avatars/avatar_88048_2023-06-13T12_20_07.5002939%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26509,
    name: 'Elizabeth Peterson',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88050/avatars/avatar_88050_2023-06-13T12_22_28.7101129%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26508,
    name: 'Thomas Jackson',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88049/avatars/avatar_88049_2023-06-13T12_22_18.1837207%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26512,
    name: 'William Davis',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88053/avatars/avatar_88053_2023-06-13T12_23_39.4373199%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  {
    TenantRoomId: 26510,
    name: 'James Wilson',
    FloorplanId: 118,
    uuid: '15',
    status: 'active',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88051/avatars/avatar_88051_2023-06-13T12_22_44.8530087%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.12' },
      { key: 'ATT', value: '00:15:32' },
      { key: 'MCAPH', value: '9' },
    ],
  },
  // 119
  {
    FloorplanId: 119,
    TenantRoomId: 26501,
    uuid: '15',
    name: 'Susan Brown',
    status: 'busy',
    avatar_url:
      'https://wlkostorage.blob.core.windows.net/assets/875/88042/avatars/avatar_88042_2023-06-13T12_11_42.5161151%2B00_00.png',
    kpis: [
      { key: 'ASA', value: '00.00.34' },
      { key: 'FCR', value: '65%' },
      { key: 'SC+', value: '7' },
    ],
  },
];

export const AvailableUsers = [
  { name: 'Jaya Parihar' },
  { name: 'Nik Chanda' },
  { name: 'Lauren Burnside' },
  { name: 'Jaya Parihar' },
  { name: 'Nik Chanda' },
  { name: 'Lauren Burnside' },
  { name: 'Jaya Parihar' },
  { name: 'Nik Chanda' },
  { name: 'Lauren Burnside' },
  { name: 'Jaya Parihar' },
  { name: 'Nik Chanda' },
  { name: 'Lauren Burnside' },
];

export const AwayUsers = [{ name: 'Arun Prabu' }, { name: 'Rodrigo Salinas' }];

export const LockedUsers = [{ name: 'Namrata Dubey' }];

export const purpleUsers = [{ name: 'Lauren Burnside' }];
export const greenUSers = [{ name: 'Nik Chanda' }];
export const infoUsers = [{ name: 'Rodrigo Salinas' }];
export const redUsers = [{ name: 'Arun Prabu' }];
